import React from 'react';

const MoversTable = ({ data }) => {
  return (
    <div className="main-content-wrapper">
      <table className="movers-table">
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Ticker</th>
            <th>Empresa</th>
            <th>Últ. Preço</th>
            <th>Variação %</th>
            <th>Volume</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.type === 'gainer' ? '🚀' : '📉'}</td>
              <td className="ticker-cell">{item.ticker}</td>
              <td className="company-cell">{item.company}</td>
              <td>R$ {item.last.toFixed(2)}</td>
              <td className={`change-cell ${item.change > 0 ? 'value-green' : 'value-red'}`}>
                {item.change.toFixed(2)}%
              </td>
              <td>{item.volume}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MoversTable;